import api from './api';
import {
  SessionProgress,
  CompletionStats,
  StepProgress,
  StudentOverview,
} from '../types/progress.types';
import { DashboardData, SummaryData } from '../types/dashboard.types';

export const progressService = {
  async joinSession(sessionId: string): Promise<SessionProgress> {
    const response = await api.post(`/sessions/${sessionId}/join`);
    return response.data;
  },

  async getSessionProgress(sessionId: string): Promise<SessionProgress> {
    const response = await api.get(`/sessions/${sessionId}/progress`);
    return response.data;
  },

  async markStepInProgress(progressId: string): Promise<StepProgress> {
    const response = await api.patch(`/progress/${progressId}/start`);
    return response.data;
  },

  async markStepComplete(progressId: string): Promise<StepProgress> {
    const response = await api.patch(`/progress/${progressId}/complete`);
    return response.data;
  },

  async getCompletionStats(sessionId: string): Promise<CompletionStats> {
    const response = await api.get(`/sessions/${sessionId}/completion`);
    return response.data;
  },

  async getSessionOverview(sessionId: string): Promise<StudentOverview[]> {
    const response = await api.get(`/sessions/${sessionId}/overview`);
    return response.data;
  },

  async getDashboardData(sessionId: string): Promise<DashboardData> {
    const response = await api.get(`/sessions/${sessionId}/dashboard`);
    return response.data;
  },

  async getSessionSummary(sessionId: string): Promise<SummaryData> {
    const response = await api.get(`/sessions/${sessionId}/summary`);
    return response.data;
  },

  async getStudentChecklistDetail(sessionId: string, studentId: string): Promise<{ steps: Array<{ stepId: string; stepTitle: string; orderIndex: number; status: string; completionCriteria: string; checklistItems: Array<{ id: string; text: string; checked: boolean }> }> }> {
    const response = await api.get(`/sessions/${sessionId}/students/${studentId}/checklist-detail`);
    return response.data;
  },

  async updateChecklistItem(progressId: string, itemId: string, checked: boolean): Promise<{ checklistState: Record<string, boolean> }> {
    const response = await api.patch(`/progress/${progressId}/checklist`, { itemId, checked });
    return response.data;
  },

  async getMyDesktopStatus(sessionId: string): Promise<{ status: 'grace' | 'expired' | 'destroyed' | 'none'; ttlExpiresAt: string | null }> {
    const response = await api.get(`/sessions/${sessionId}/my-desktop-status`);
    return response.data;
  },

};
